import { sendRequest, sendRequestJson } from '@/utils'
import configModule from '@/store/configModule'

class UserRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async find(uid) {
		const url = configModule.state.wePassUrl + '/world/api/user/find'
		try {
			return await sendRequestJson({ data: { uid }, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal obteniendo la informacion del usuario.')
		}
	}

	async checkEmail(email, noMail) {
		const url = configModule.state.wePassUrl + '/world/user/remindnumber'
		try {
			return await sendRequest({ data: { email, noMail }, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal obteniendo la informacion del usuario.')
		}
	}

	async registerUserFromInvitation(data) {
		const url = this.urlBase + '/world/user/register'
		try {
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal terminando creando el usuario por invitacion')
		}
	}

	async createGuestUserMenu(data) {
		const url = this.urlBase + '/world/api/user/createguestusermenu'
		try {
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal terminando creando el usuario invitado para el menu')
		}
	}

	async sendPass(uid) {
		const data = { uid }
		const url = this.urlBase + '/world/api/user/sendpass'
		try {
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal terminando creando el usuario invitado para el menu')
		}
	}

	async getReservationsUser(uid) {
		const url = this.urlBase + '/world/reservation/userfuture'
		return await sendRequestJson({ data: { uid }, url, method: 'POST' })
	}

	async registerLog(data) {
		const url = this.urlBase + '/world/doorlog/register'
		try {
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal terminando creando el usuario invitado para el menu')
		}
	}

	async checkLog(welkhomeKey, userId) {
		const currentDate = new Date()
		const limitDate = new Date(currentDate)
		limitDate.setDate(currentDate.getDate() - 1)
		const data = {
			welkhomeKey: welkhomeKey,
			dateFrom: limitDate,
			dateTo: currentDate,
			userId: userId
		}
		const url = `${this.urlBase}world/doorlog/history`
		try {
			return await sendRequest({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal consultando los logs')
		}
	}

	async updateAllergens(uid, allergensId) {
		const url = this.urlBase + '/world/api/user/updateallergens'
		try {
			return await sendRequestJson({ data: { uid, allergensId }, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal actualizando las alergias del usuario')
		}
	}

	async sendComment(uid, comment) {
		const url = this.urlBase + '/world/api/webcontact/sendcomment'
		try {
			return await sendRequestJson({ data: { uid, comment }, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal enviando el comentario')
		}
	}

	async login(userEmail, password) {
		const url = this.urlBase + '/world/api/user/login'
		try {
			return await sendRequestJson({ data: { userEmail, password }, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal logeando al usuario', e)
		}
	}

	async loginWithToken(token) {
		const url = this.urlBase + '/world/api/user/check-access'
		try {
			return await sendRequestJson({ url, method: 'GET', token })
		} catch (e) {
			console.log('Ups, algo ha ido mal logeando al usuario con token', e)
		}
	}

	async loginCopilot(userEmail, password) {
		const url = this.urlBase + '/world/api/user/login-app'
		try {
			return await sendRequestJson({
				data: { userEmail, password, appContext: 'copilot' },
				url,
				method: 'POST',
			})
		} catch (e) {
			console.log('Ups, algo ha ido mal logeando al usuario en copilot', e)
		}
	}

	async checkRoleCopilot() {
		const url = this.urlBase + '/world/api/user/check-access?app=copilot'
		try {
			return await sendRequestJson({ data: null, url, method: 'GET' })
		} catch (e) {
			console.log('Ups, algo ha ido mal comprobando el role del usuario para copilot', e)
		}
	}

	async checkRoleKiosk() {
		const url = this.urlBase + '/world/api/user/check-access?app=kiosk'
		try {
			return await sendRequestJson({ data: null, url, method: 'GET' })
		} catch (e) {
			console.log('Ups, algo ha ido mal comprobando el role del usuario para kiosk', e)
		}
	}

	async checkRoleAdmin() {
		const url = this.urlBase + '/world/api/user/check-access?app=admin'
		try {
			return await sendRequestJson({ data: null, url, method: 'GET' })
		} catch (e) {
			console.log('Ups, algo ha ido mal comprobando el role del usuario para admin', e)
		}
	}

	async updateUserName(userName) {
		const url = this.urlBase + '/world/api/user/update-user-name'
		try {
			return await sendRequestJson({ data: { userName }, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal comprobando el role del usuario para admin', e)
		}
	}
}

export const userRepository = new UserRepository()
